export enum StockStatus {
  LOW_STOCK = 'low-stock',
  OUT_OF_STOCK = 'out-of-stock',
  CLOSE_TO_EXPIRY = 'close-to-expiry',
  ALL = 'all',
}